import { supabase } from "@/integrations/supabase/client";

export interface JobScrapingResult {
  success: boolean;
  content?: string;
  portal?: string;
  url?: string;
  error?: string;
}

export class JobScrapingService {
  
  static async scrapeJobUrl(url: string): Promise<JobScrapingResult> {
    try {
      const { data, error } = await supabase.functions.invoke('scrape-job-url', {
        body: { url }
      });

      if (error) {
        console.error('Supabase function error:', error);
        throw new Error(error.message || 'Failed to invoke scraping function');
      }

      if (!data.success) {
        throw new Error(data.error || 'Scraping failed');
      }

      return {
        success: true,
        content: data.content,
        portal: data.portal,
        url: data.url
      };
      
    } catch (error) {
      console.error('Job scraping error:', error);
      return {
        success: false,
        error: error instanceof Error ? error.message : 'Unknown error occurred'
      };
    }
  }

  static getSupportedPortals(): string[] {
    return [
      'LinkedIn',
      'Indeed', 
      'Glassdoor',
      'ZipRecruiter',
      'Monster',
      'CareerBuilder',
      'AngelList (Wellfound)',
      'Stack Overflow Jobs',
      'And many other job sites...'
    ];
  }

  static isJobPortalUrl(url: string): boolean {
    const jobPortalDomains = [
      'linkedin.com',
      'indeed.com', 
      'glassdoor.com',
      'ziprecruiter.com',
      'monster.com',
      'careerbuilder.com',
      'angel.co',
      'wellfound.com',
      'stackoverflow.com/jobs',
      'dice.com',
      'simplyhired.com',
      'flexjobs.com',
      'upwork.com',
      'freelancer.com'
    ];

    const urlLower = url.toLowerCase();
    return jobPortalDomains.some(domain => urlLower.includes(domain));
  }
}